import { render, staticRenderFns } from "./ModalBackofficeAnestesistas.vue?vue&type=template&id=3af0177c&scoped=true"
import script from "./ModalBackofficeAnestesistas.vue?vue&type=script&lang=ts"
export * from "./ModalBackofficeAnestesistas.vue?vue&type=script&lang=ts"
import style0 from "./ModalBackofficeAnestesistas.vue?vue&type=style&index=0&id=3af0177c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af0177c",
  null
  
)

export default component.exports